// layouts
import Header from "../../../../../layouts/template/charge/header/header";
// link
import {Link} from "react-router-dom";

const HamiyanError = () => {
    return (
        <>
            <article className={'payment container-fluid h-100 overflow-x-hidden'}>
                <div className="row justify-content-center align-items-center h-100">
                    <div className="col-12">
                        <div id={'text-field'}>
                            <Header/>
                            <section className={'profile container'}>
                                <div className={'profile-items d-flex justify-content-center text-center'}>
                                    <div className={'profile-img position-relative'}
                                         style={{backgroundImage: `url(${require('../../../../../assets/media/images/payment/hamiyan.png')})`}}></div>
                                </div>
                                <p className={'h5 card-text fw-bold text-white mt-1 mb-1'}>
                                    پویش مردمی حامیان مقاومت
                                </p>
                            </section>
                            <section className={'bg-white text-center py-3 my-3'}>
                                <h3 className={'text-ir-danger fw-bold mb-0'}>
                                    پرداخت انجام نشد
                                </h3>
                            </section>
                            <div className={'d-flex justify-content-center mb-2 mt-2'}>
                                <Link id={'share'} to='/'
                                      className={'dark-green font-small mb-2 py-1 rounded-pill align-middle font-medium btn-site btn fw-bold'}>
                                    اینجا کلیک کن و تو هم ایران تراکنشی شو...
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </>
    )
}

export default HamiyanError;